import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { App } from "./App";
import { applyPolyfills } from "./browserUtils";
import { DataLayer, ItemFilter } from "./DataLayer";
import { Auth } from "./Auth";

if (window.self === window.top) {
  //don't render if we are in an iframe
  applyPolyfills(() => {
    console.log("Creating <App> with URL " + window.document.location);
    const auth = new Auth();

    // If query string contains "onlyPhotos=true", apply that filter
    const urlParams = new URLSearchParams(window.location.search);
    const onlyPhotosParam = urlParams.get("onlyPhotos");
    let itemFilter: ItemFilter | undefined = undefined;
    if (onlyPhotosParam && onlyPhotosParam.toLowerCase() === "true") {
      itemFilter = "onlyPhotos";
    }

    const dataLayer = new DataLayer(auth, itemFilter);
    ReactDOM.render(<App dataLayer={dataLayer} auth={auth} />, document.getElementById("root"));
  });
}
